import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(sessionStorage.getItem('user'))||{"accountNumber": "","name": "",},
    cancelTokenArr: [] // 取消请求token数组
  },
  mutations: {
    editUser(state, data) {
      state.user = data
    },
    pushToken (state, cancel) { 
        state.cancelTokenArr.push(cancel) 
    },
    clearToken (state) { 
        state.cancelTokenArr.forEach(item => { 
            item.cancel() 
        }) 
        state.cancelTokenArr = [] 
    }
  },
  actions: {
  },
  modules: {
  }
})
